import { PopoverPlacement } from "@idui/react-popover";
import { FC, PropsWithChildren } from "react";
import { useRecoilValue } from "recoil";

import { useApplication, useRtl } from "@ryde/redux";
import {
  DragTypeEnum,
  ridesDraggingDataAtom,
  useDebugMode,
} from "@ryde/shared";

import {
  NavButtonTooltipAdminStyled,
  NavButtonTooltipStyled,
} from "./left-bar.styled";

interface INavButtonTooltipWrapper extends PropsWithChildren {
  tooltip: string;
}

export const NavButtonTooltipWrapper: FC<INavButtonTooltipWrapper> = ({
  tooltip,
  children,
}) => {
  const { isRtl } = useRtl();
  const { isAdminApp } = useApplication();
  const { isNonProductionNavbarColor } = useDebugMode();
  const dragStatus = useRecoilValue(ridesDraggingDataAtom);

  if (dragStatus && dragStatus?.type !== DragTypeEnum.NOT_DRAGGING) {
    return children;
  }

  if (isAdminApp) {
    return (
      <NavButtonTooltipAdminStyled
        $isNonProductionNavbarColor={isNonProductionNavbarColor}
        title={tooltip}
        content={tooltip}
        closeOnRemoteClick
        spaceBetweenPopoverAndTarget={13}
        placement={isRtl ? PopoverPlacement.left : PopoverPlacement.right}
      >
        <>{children}</>
      </NavButtonTooltipAdminStyled>
    );
  }

  return (
    <NavButtonTooltipStyled
      $isNonProductionNavbarColor={isNonProductionNavbarColor}
      title={tooltip}
      content={tooltip}
      closeOnRemoteClick
      spaceBetweenPopoverAndTarget={13}
      placement={isRtl ? PopoverPlacement.left : PopoverPlacement.right}
    >
      <>{children}</>
    </NavButtonTooltipStyled>
  );
};
